import { render, staticRenderFns } from "./examineListDetail.vue?vue&type=template&id=18d77760&scoped=true"
import script from "./examineListDetail.vue?vue&type=script&lang=js"
export * from "./examineListDetail.vue?vue&type=script&lang=js"
import style0 from "./examineListDetail.vue?vue&type=style&index=0&id=18d77760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d77760",
  null
  
)

export default component.exports